/*
 * @Description:设计项目定义
 * @Autor: lx
 */
import request from '@/utils/request'

//@ 查询
export function getAllData(data) {
  return request({
    url: '/plus_project/GetAll',
    method: 'post',
    data,
  })
}

//@ 添加
export function addData(data) {
  return request({
    url: '/plus_project/AddOne',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

//@ 更新
export function updateData(data) {
  return request({
    url: '/plus_project/UpdateSingle',
    method: 'post',
    data,
  })
}
//@ 删除
export function deleteData(data) {
  return request({
    url: '/plus_project/DeleteById',
    method: 'get',
    params: data,
  })
}

//@ 查询
export function getProjectType(data) {
  return request({
    url: '/plus_project/GetProjectType',
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}
//@ 查询
export function getLocation(data) {
  return request({
    url: '/plus_project/GetLocation',
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}
//@ 查询
export function getProjectStatus(data) {
  return request({
    url: '/plus_project/GetProjectStatus',
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}
